'use client';
import React from 'react'

interface ShiningNumbersProps {
	number: string
	size: number
	active: boolean
}

const SIZE_TO_TEXT_STYLE: Record<number, string> = {
	76: 'text-36-to-24-no-leading--neue-june',
	64: 'text-28-no-leading--neue-june',
	56: 'text-24-fixed-no-leading--neue-june',
	48: 'text-20-fixed-no-leading--neue-june',
	44: 'text-20-fixed-no-leading--neue-june',
}

// Calculated from previous SIZE_TO_DIMENSIONS (in rem) relative to font size
// 76: 4.75rem (76px) / 36px = 2.125em
// 64: 4rem (64px) / 28px = 2.286em
// 56: 3.5rem (56px) / 24px = 2.333em
// 48: 3rem (48px) / 20px = 2.4em
// 44: 2.75rem (44px) / 20px = 2.2em
const SIZE_TO_EM_DIMENSIONS: Record<number, string> = {
	76: '2.125em',
	64: '2.286em',
	56: '2.333em',
	48: '2.4em',
	44: '2.2em',
}

const ShiningNumbers: React.FC<ShiningNumbersProps> = ({
	number,
	size,
	active
}) => {

	return (
		<div
			style={{
				width: SIZE_TO_EM_DIMENSIONS[size],
				height: SIZE_TO_EM_DIMENSIONS[size],
			}}
			className={`
				flex flex-col
				justify-center
				items-center	
				text-center

				rounded-full
				border-main
				self-center

				${SIZE_TO_TEXT_STYLE[size]}
				
				transition-all duration-300

				${active ?
					`
						bg-theme-yellow-primary-base
						shadow-sunshine-primary-glow
						text-text-reversed		
						border-theme-yellow-primary-light
					`
					:
					`
						bg-bg-light-primary
						shadow-none
						text-text-disabled
						border-stroke-soft-200
					`
				}
			`}
		>
			<p className="text-center font-size-[1em]">
				{number}
			</p>
		</div>
	);
}

export default ShiningNumbers;
